module.exports = __webpack_public_path__ + "static/media/not-feeling-good-enough-large@2x.95086ea9.png";